// extracted by mini-css-extract-plugin
export default {"internetModal":"NoInternetModal_internetModal__gp9JS"};